import React from "react";
import "./instituteArticleTile.scss";
import { ArrowRight } from "@carbon/icons-react";
import { Tag, SkeletonPlaceholder } from "@carbon/react";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function InstituteArticleTile({
  title,
  desc,
  name,
  instituteArticles,
  isInstitutePending,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isCompleted = instituteArticles.find(
    (item) => name === item.name && item.completed === true
  );
  return (
    <>
      {isInstitutePending ? (
        <SkeletonPlaceholder className="tile_skeleton" />
      ) : (
        <div
          className={isCompleted ? "tile_main_completed" : "tile_main"}
          onClick={() => navigate(`/institute/${name}`)}
        >
          <h2>{t(title)}</h2>
          <p>
            <Trans i18nKey={desc} />
          </p>
          <ArrowRight fill="blue" className="tile_main_arrow" />
          {isCompleted ? (
            <Tag
              className="tile_main_tag"
              size="md"
              type="green"
            >
              {t("main.institute.passed")}
            </Tag>
          ) : null}
        </div>
      )}
    </>
  );
}
